interface PodcastCardSkeletonProps {
  background?: 'grey' | 'white';
}

function PodcastCardSkeleton({ background = 'grey' }: PodcastCardSkeletonProps) {
  return (
    <article
      role='status'
      className={`rounded-md border border-gray-300 p-4 py-3 flex gap-4 items-center ${background === 'white' ? 'bg-white' : 'bg-[#E4E4E440]'}`}
    >
      <div className='min-w-20 min-h-20 object-cover rounded-md border border-gray-300 bg-gray-200 animate-pulse' />

      <div className='flex flex-col justify-between min-h-[85%] w-full'>
        <div>
          <div className='h-4 bg-gray-200 animate-pulse rounded-full w-full' />
          <div className='h-4 mt-1 bg-gray-200 animate-pulse rounded-full w-[90%]' />
          <div className='h-4 mt-1 bg-gray-200 animate-pulse rounded-full w-[75%]' />
        </div>

        <div>
          <div className='bg-gray-200 animate-pull rounded-full h-3 w-[50%] mt-2' />
        </div>
      </div>

      <div className='mr-[2px] min-w-[42px] min-h-[42px] bg-gray-200 animate-pulse rounded-full' />
    </article>
  );
}

export default PodcastCardSkeleton;
